const HOME = '/';
const LOGIN = '/login';
const LOGOUT = '/logout';
const SIGNUP = '/signup';
const CODE_SIGNUP = '/code-signup';
const VERIFY_EMAIL = '/verifyEmail';
const NOT_FOUND = '/*';
const MERCHANTS = '/cluster/:clusterId';
const OFFERS = '/cluster/:clusterId/merchant/:merchantId';
const LANDING = '/:displayId';
const RESET_PASSWORD = '/account/reset';
const CLUSTER_EXPIRED = '/cluster/:clusterId/expired';
const SEASON_CAMPAIGN = '/seasonCampaign/:seasonCampaignId';
const GIFT_CHECK_EMAIL =
  '/cluster/:clusterId/giftCollection/:giftCollectionId/checkEmail';
const ENTER_CODE = '/enterCode';

const AppRoutes = {
  HOME,
  LOGIN,
  NOT_FOUND,
  SIGNUP,
  MERCHANTS,
  VERIFY_EMAIL,
  LOGOUT,
  OFFERS,
  LANDING,
  CODE_SIGNUP,
  RESET_PASSWORD,
  CLUSTER_EXPIRED,
  SEASON_CAMPAIGN,
  GIFT_CHECK_EMAIL,
  ENTER_CODE,
};

export default AppRoutes;
